module.exports = __webpack_public_path__ + "static/media/Group 3.232d7ad6.png";